import { render } from "./PartsAndServices.vue?vue&type=template&id=56b0dbfe"
import script from "./PartsAndServices.vue?vue&type=script&lang=js"
export * from "./PartsAndServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__